export default __webpack_public_path__ + "static/media/IconVacancyConditions.4a46b43b.png";